import React from "react";
import { Menu, MenuButton, MenuDivider, MenuItem } from "@szhsin/react-menu";
import { useDispatch, useSelector } from "react-redux";
import { fetchActions } from "../redux/usersSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { IconDots } from "./../../../../assets/images/svg";

export function UserActionsMenu({ item, onMenuItemClick }) {
  const dispatch = useDispatch();
  const currentUserActions = useSelector((state) => state.users.currentUserActions);
  const actionsLoading = useSelector((state) => state.users.actionsLoading);

  return (
    <Menu
      portal
      menuButton={
        <MenuButton title="Actions">
          <IconDots />
        </MenuButton>
      }
      onMenuChange={({ open }) => {
        if (open) {
          dispatch(fetchActions(item.id));
        }
      }}
      onItemClick={(eventObj) => onMenuItemClick(eventObj, item)}
      direction="left"
      align="start"
      transition
    >
      {actionsLoading ? (
        <LoadingAnimation uiLoader />
      ) : (
        <>
          {currentUserActions.canUnlockAccount && (
            <>
              <MenuItem value="unlockAccount">
                <span>Unlock account</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}
          {currentUserActions.canDuplicate && (
            <>
              <MenuItem value="duplicate">
                <span>Duplicate</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canMirror && (
            <>
              <MenuItem value="mirror">
                <span>Mirror</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canLoginAs && (
            <>
              <MenuItem value="loginAs">
                <span>Login As</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canBeSetAsAdmin && (
            <>
              <MenuItem value="setAdmin">
                <span>Set Admin Role</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canSendDailyReportEmail && (
            <>
              <MenuItem value="sendDailyReportEmail">
                <span>Send Daily Email</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canSendUsaPtDailyStatSheetEmail && (
            <>
              <MenuItem value="usaPtDailyStatSheetEmail">
                <span>Send USA PT Daily Stat Sheet Email</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canSendLocationComparisonDailyEmail && (
            <>
              <MenuItem value="locationComparisonDailyEmail">
                <span>Send Location Comparison Email</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canSendInactiveUsersEmail && (
            <>
              <MenuItem value="inactiveUsersEmail">
                <span>Send no activity users email</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canSendWelcomeEmail && (
            <>
              <MenuItem value="welcomeEmail">
                <span>Send Welcome Email</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}

          {currentUserActions.canSendResetPasswordInstructions && (
            <>
              <MenuItem value="resetPasswordInstructions">
                <span>Send Reset Password Instruction</span>
              </MenuItem>
              <MenuDivider />
            </>
          )}
        </>
      )}
    </Menu>
  );
}
